import { useState } from "react";
import { ProductType } from "../../../services/types/productType.type";
import { CardTitle } from "../../ui/text/CardTitle/CardTitle";
import { BorderWrap } from "../../ui/wrappers/BorderWrap/BorderWrap";
import "./TypeItem.css";
import { TextButton } from "../../ui/buttons/TextButton/TextButton";
import { useAppSelector } from "../../../services/hooks/useAppHooks";
import { useDeleteProductTypeMutation } from "../../../store/productTypes/productTypesApi";
import { ItemMenu } from "../../ui/ItemMenu/ItemMenu";

interface TypeItemProps {
  item: ProductType;
  editAction: (uuid: string) => void;
  updatePage: () => void;
}

export const TypeItem = ({ item, editAction, updatePage }: TypeItemProps) => {
  const { user } = useAppSelector((state) => state.auth);
  const [showMenu, setShowMenu] = useState(false);
  const [deleteProductType] = useDeleteProductTypeMutation();

  const menuClick = () => {
    setShowMenu((showMenu) => !showMenu);
  };

  const editItem = () => {
    editAction(item.uuid);
    setShowMenu(false);
  };

  const deleteItem = async () => {
    if (window.confirm("Вы действительно хотите удалить этот тип?")) {
      try {
        await deleteProductType(item.uuid).unwrap();
        updatePage();
      } catch (err) {
        console.error("Ошибка удаления типа", err);
      }
    }
  };

  return (
    <BorderWrap>
      <ItemMenu showMenu={showMenu} menuClick={menuClick}>
        <TextButton text="Редактировать" action={editItem} />
        {user && (user.role === "admin" || user.role === "superadmin") ? (
          <TextButton text="Удалить" margin="1rem 0 0 0" action={deleteItem} />
        ) : (
          <></>
        )}
      </ItemMenu>
      <CardTitle title={item.name} margin="1rem 0 0" />
    </BorderWrap>
  );
};
